package com.anjuros.website.redesign.sections.blogarticle

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdLink
import com.anjuros.website.redesign.components.RdPicture
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdSectionHead
import com.anjuros.website.redesign.sections.blog.BlogGuides
import com.anjuros.website.redesign.sections.blog.BlogMeta
import com.anjuros.website.redesign.sections.blog.RdBlogGuide
import com.anjuros.website.redesign.styles.ArticleMoreCardStyle
import com.anjuros.website.redesign.styles.ArticleMoreGridStyle
import com.anjuros.website.redesign.styles.RdSectionFlushTopStyle
import com.anjuros.website.redesign.styles.RdSectionStyle
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Text

private const val MORE_GUIDES = 2

/** The newest other articles, to keep reading. */
@Composable
fun ArticleMoreSection(current: RdBlogGuide) {
    val others = BlogGuides.filter { it.card != current.card }.sortedByDescending { it.published }.take(MORE_GUIDES)
    if (others.isEmpty()) return
    RdSection(
        id = "more",
        labelledBy = "more-h",
        modifier = RdSectionStyle.toModifier().then(RdSectionFlushTopStyle.toModifier()),
    ) {
        RdSectionHead(RdText.BLOG_MORE_EYEBROW, "more-h", RdText.BLOG_MORE_TITLE)
        Div(ArticleMoreGridStyle.toModifier().toAttrs()) {
            others.forEach { guide ->
                RdLink(guide.card.pathToArticle, ArticleMoreCardStyle.toModifier()) {
                    RdPicture(guide.image, alt = "")
                    Div {
                        BlogMeta(guide)
                        H3 { Text(LocalText(guide.card.title)) }
                    }
                }
            }
        }
    }
}
